<ng-container *ngrxLet="{ countryName: countryName$ } as vm">
    <span
        *ngIf="country$ | ngrxPush as country"
        [ngClass]="['fi', 'fi-' + country, 'fis']"
        role="img"
        [attr.aria-label]="vm.countryName ? ('dtmUi.flagLabel' | transloco : { country: vm.countryName }) : null"
    ></span>
</ng-container>
